import { Slider } from 'components/molecules/Slider'
import { Card } from 'components/organisms/Card'
import { Section } from 'components/organisms/Section'
import type { CommissionProps } from './types'

import { ECommissionVariant } from './enums'

import './index.scss'

const mainClass = 'commission'

type RenderCardParams = {
  key: string
  item: NonNullable<CommissionProps['list']>[number]
  modifier: string
  index: number
}

const cardRenderers: Record<
  ECommissionVariant,
  (params: RenderCardParams) => React.ReactElement
> = {
  [ECommissionVariant.CIRCULAR]: ({ key, item, index }) => (
    <Card
      key={key}
      variant={ECommissionVariant.CIRCULAR}
      title={item.title}
      level={item.level}
      percentage={item.percentage}
      range={item.range}
      index={index}
    />
  ),
  [ECommissionVariant.LIST]: ({ key, item, modifier }) => (
    <Card
      key={key}
      variant={ECommissionVariant.LIST}
      title={item.title}
      image={item.image}
      list={item.list}
      modifier={modifier}
    />
  ),
  [ECommissionVariant.DEFAULT]: ({ key, item, modifier }) => (
    <Card
      key={key}
      variant={ECommissionVariant.DEFAULT}
      title={item.title}
      image={item.image}
      text={item.text}
      modifier={modifier}
    />
  ),
}

const renderCard = (
  variant: CommissionProps['variant'],
  item: NonNullable<CommissionProps['list']>[number],
  modifier: string,
  index: number
) => {
  if (!item) return null

  const key = item.title || `item-${index}`
  const renderer = cardRenderers[variant || ECommissionVariant.DEFAULT]

  return renderer({ key, item, modifier, index })
}

export const Commission = ({
  variant = ECommissionVariant.DEFAULT,
  title,
  subtitle,
  note,
  action,
  list = [],
  modifier = 'card--primary',
}: CommissionProps) => {
  if (!title || !list.length) {
    return null
  }

  const shouldShowNavigation = variant !== ECommissionVariant.CIRCULAR

  return (
    <Section
      id="_commission"
      className={mainClass}
      title={title}
      subtitle={subtitle}
      note={note}
      action={action}
    >
      <span/>
    </Section>
  )
}
